import { useQuery } from '@apollo/client';
import { REFRESHMENTS_URLS } from '../../constants';
import { NBSubscriptionStatus } from '../../types/enums';
import { getRefreshmentsPaymentUpdatedCookie, getUserDismissedPaymentFailurePageCookie, } from '../../utils/cookies';
import { getCurrentYearAndMonth } from '../../utils/dates';
import useBusinessConfiguration from '../useBusinessConfiguration';
import GET_PAYMENT_FAILURE_INFORMATION from './GET_PAYMENT_FAILURE_INFORMATION';
var usePaymentFailureInformation = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var _j = useBusinessConfiguration(), program = _j.program, tenant = _j.tenant;
    var _k = getCurrentYearAndMonth(), year = _k.year, month = _k.month;
    var _l = useQuery(GET_PAYMENT_FAILURE_INFORMATION, {
        variables: {
            program: program,
            year: year.toString(),
            month: month.toString(),
        },
        errorPolicy: 'ignore',
    }), data = _l.data, loading = _l.loading, error = _l.error;
    var isPaymentFailurePageEnabled = !!((_a = data === null || data === void 0 ? void 0 : data.me.layout) === null || _a === void 0 ? void 0 : _a.paymentFailurePageFlag);
    var updatePaymentMethodURL = REFRESHMENTS_URLS.UPDATE_PAYMENT_METHOD[tenant];
    var isUserActive = ((_c = (_b = data === null || data === void 0 ? void 0 : data.me) === null || _b === void 0 ? void 0 : _b.subscription) === null || _c === void 0 ? void 0 : _c.status) === NBSubscriptionStatus.ACTIVE;
    var isUserInPaymentFailure = isUserActive && !!((_e = (_d = data === null || data === void 0 ? void 0 : data.me) === null || _d === void 0 ? void 0 : _d.subscription) === null || _e === void 0 ? void 0 : _e.paymentFailureIndicator);
    var hasUserDismissedPaymentFailurePage = getUserDismissedPaymentFailurePageCookie() === 'true';
    var cookieCycledId = getRefreshmentsPaymentUpdatedCookie(data === null || data === void 0 ? void 0 : data.me.id);
    var currentCycleId = (_h = (_g = (_f = data === null || data === void 0 ? void 0 : data.me) === null || _f === void 0 ? void 0 : _f.subscriptionProgram) === null || _g === void 0 ? void 0 : _g.subscriptionCycle) === null || _h === void 0 ? void 0 : _h.id;
    var hasUserUpdatedPaymentMethod = cookieCycledId === currentCycleId;
    var shouldUserSeePaymentFailurePage = isPaymentFailurePageEnabled &&
        isUserInPaymentFailure &&
        !hasUserUpdatedPaymentMethod &&
        !hasUserDismissedPaymentFailurePage;
    return {
        loading: loading,
        error: error,
        isUserInPaymentFailure: isUserInPaymentFailure,
        hasUserUpdatedPaymentMethod: hasUserUpdatedPaymentMethod,
        shouldUserSeePaymentFailurePage: shouldUserSeePaymentFailurePage,
        updatePaymentMethodURL: updatePaymentMethodURL,
    };
};
export default usePaymentFailureInformation;
